import { MultiListBoxItem } from '../cpq-multi-list-box-with-selection/multi-list-box-item.model';
import { ICpqMultiListBoxService } from './cpq-multi-list-box-with-recursion-dialog.service';

export class CpqMultiListBoxData<Type = number> {
  public selectedItems: Array<Type>;
  public isMultiSelect = true;
  public productName?: string;
  public showApplyPermissionsToggle?: boolean;
  public title?: string;
  public multiSelectTitle?: string;
  public service: ICpqMultiListBoxService<Type>; 
  public selectableItemIds?: Array<Type>; 
}

export class CpqMultiListBoxResult {   
  public selectedItemsIds: Array<MultiListBoxItem>;
  public applyParentPermissions: boolean;
}